export default "__VITE_ASSET__DmFGFKpn__"